export const environment = {
    production: true,
    bankApiUrl: 'https://api-bank.grayfield-eb967598.eastus.azurecontainerapps.io',
    companyApiUrl: 'https://api-company.grayfield-eb967598.eastus.azurecontainerapps.io',
    portalApiUrl: 'https://api-portal.grayfield-eb967598.eastus.azurecontainerapps.io',
    purchaseOrderApiUrl: 'https://api-company.grayfield-eb967598.eastus.azurecontainerapps.io',
    reconciliationApiUrl: 'https://api-company.grayfield-eb967598.eastus.azurecontainerapps.io',
    reconciliationRuleApiUrl: 'https://api-company.grayfield-eb967598.eastus.azurecontainerapps.io',
    transactionApiUrl: 'https://api-company.grayfield-eb967598.eastus.azurecontainerapps.io'
};
